import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Transition from 'components/utils/transition';

export default class Tools extends Component {
    static propTypes = {
        results: ImmutablePropTypes.list.isRequired,
        resultIndex: PropTypes.number.isRequired,
        compact: PropTypes.bool.isRequired,
        rtl: PropTypes.bool.isRequired,
        prevResult: PropTypes.func.isRequired,
        nextResult: PropTypes.func.isRequired,
        clear: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.results !== this.props.results
            || nextProps.resultIndex !== this.props.resultIndex
            || nextProps.compact !== this.props.compact
            || nextProps.rtl !== this.props.rtl
            || nextProps.prevResult !== this.props.prevResult
            || nextProps.nextResult !== this.props.nextResult
            || nextProps.clear !== this.props.clear;
    }

    render() {
        const {results, resultIndex, compact, rtl} = this.props;
        let children;

        if (results.size > 0) {
            const activeResult = results.get(resultIndex);
            children = (
                <div className='cielo24-vwrap-tools'>
                    <div className='cielo24-vwrap-type cielo24-vwrap-pill'>
                        {i18next.t(activeResult.get('type'))}
                    </div>
                    <div className='cielo24-vwrap-count'>
                        <span>{resultIndex + 1}</span>
                        <span className='cielo24-vwrap-spacer'> / </span>
                        <span>{results.size}</span>
                    </div>
                    <button
                        type='button'
                        className='cielo24-vwrap-previous'
                        disabled={results.size === 0}
                        onClick={this.props.prevResult}
                        title={i18next.t('Previous')}
                        aria-label={i18next.t('Previous')}
                    >
                        <i
                            className={`cielo24-vwrap-icon cielo24-vwrap-icon-chevron-${rtl ? 'right' : 'left'}-thin`}
                            aria-hidden={true}
                        />
                    </button>
                    <button
                        type='button'
                        className='cielo24-vwrap-next'
                        disabled={results.size === 0}
                        onClick={this.props.nextResult}
                        title={i18next.t('Next')}
                        aria-label={i18next.t('Next')}
                    >
                        <i
                            className={`cielo24-vwrap-icon cielo24-vwrap-icon-chevron-${rtl ? 'left' : 'right'}-thin`}
                            aria-hidden={true}
                        />
                    </button>
                    <button
                        type='button'
                        className='cielo24-vwrap-clear'
                        onClick={this.props.clear}
                        title={i18next.t('Clear')}
                        aria-label={i18next.t('Clear')}
                    >
                        <i className='cielo24-vwrap-icon cielo24-vwrap-icon-close-thin' aria-hidden={true} />
                    </button>
                </div>
            );
        }

        const className = 'cielo24-vwrap-tools-wrapper';
        if (compact) return <div className={className}>{children}</div>;
        return <Transition className={className} name='search-tools'>{children}</Transition>;
    }
}



// WEBPACK FOOTER //
// ./scripts/components/search/tools.js